import DroppableWrapper from './component';
export default DroppableWrapper;
